import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';
import { ToastrService } from 'ngx-toastr';
import { JwtHelperService } from '@auth0/angular-jwt';
import moment from 'moment';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent implements OnInit {
  defaultData: any = [];
  loginForm: UntypedFormGroup;
  versionNo: any;
  helper = new JwtHelperService();
  pdummy: any;
  isTextFieldType1: boolean = false;
  debounceTimeout:any;
  constructor(@Inject('apiEndPoint') private apiEndPoint: string,
    @Inject('version') private version: string,
    private formBuilder: UntypedFormBuilder, private toast: ToastrService,
    public router: Router, public service: AuthService,
  ) { }
  // email: ['', [Validators.required, Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
  ngOnInit(): void {
    
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.minLength(3)]],
      password: ['', [Validators.required, Validators.minLength(3)]]
    });
    this.versionNo = this.version;
  }
  isSpinner: boolean = false;

  signInWithFacebook() {
    localStorage.setItem('socialMedia', 'facebook')
    window.open(this.apiEndPoint + '/_login/facebook', "_self");
  }
  Submit(userLoginDetails) {
    if (this.loginForm.invalid) {
      return;
    }
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(()=>{
    clearTimeout(this.debounceTimeout);
             this.isSpinner = true;
    let p: any = this.handleEncrypt(userLoginDetails.password);
    this.service.login_uibackend(userLoginDetails.email, p).subscribe((resp: any) => {
      if (resp && resp.result.jwt) {
        window.localStorage.setItem('user_id', resp.result._id);

        window.localStorage.setItem('token', resp.result.jwt);
        this.service.getUserDetails().subscribe((user: any) => {
          let profileid = user.result?._source?.user_type ? user.result?._source?.user_type : 'user';
          window.localStorage.setItem('full_name', user.result._source.fullname);
        window.localStorage.setItem('thresholds', JSON.stringify(user.result._source.thresholds));

          window.localStorage.setItem('user_type', user.result._source.user_type)
          window.localStorage.setItem('user_devices', JSON.stringify(user.result._source?.devices))
          localStorage.setItem('startegy', user.result.strategies[0])

          this.service.getRoleDetails(profileid).subscribe((role: any) => {
            let roleRightsJson = role.result._source.pages;
            this.isSpinner = false;
            this.toast.success('Login Successful');
            window.localStorage.setItem('sideMenuList', JSON.stringify(roleRightsJson));

            this.router.navigate(['/dashboard']);
            this.service.getPageNameData('Home');
            console.log(user.result);
            let time = moment.utc().valueOf();
            let time_local = moment().valueOf();
            let timeZone = moment.tz.guess();
            // let timeZone = tz?tz.toString():undefined;
            // this.service.createLoginEvent(user.result?._source?.fullname,user.result?._id,time, timeZone, user.result?._source?.user_type, "login")
            this.service.createLoginEventNotification(user.result?._source?.fullname,user.result?._id,time, timeZone, user.result?._source?.user_type, "INFO", "Login", time_local)
            .subscribe(res=>{})
          })
        })
      }
    }, error => {
      this.isSpinner = false;
      // this.toast.warning(error.message);
    });
    },1000)

  }
  handleEncrypt(value) {
    return this.service.encryptUsingAES256(value)
  }
  handleDecrypt() {
    // console.log(this.service.decrypt(this.pdummy));
  }
  togglePasswordFieldType() {  // for view password
    this.isTextFieldType1 = !this.isTextFieldType1;
  }

  getTimeData(){
    let time = moment.utc().valueOf();
    let timeZone = moment()?.['_d'];
  }
}